import ChatIcon from '@mui/icons-material/Chat';
import {
    Avatar,
    Badge,
    IconButton,
    ListItemAvatar,
    Typography,
} from '@mui/material';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import toast from '../../../shared/Toast';
import { useJoinBookingChannelMutation } from '../../../../app/Slices/SevenDayApiSlice';
import { JoinBookingChannel } from '../../../../app/Slices/SevenDayApiTypes';

const MessageItem = ({
    message,
    reservationId,
}: {
    message: any;
    reservationId: number;
}) => {
    const [joinBookingChannel] = useJoinBookingChannelMutation();
    const navigate = useNavigate();

    const onNavigate = async () => {
        try {
            const body: JoinBookingChannel = {
                bookingId: reservationId,
                channelId: message.channelId,
            };

            await joinBookingChannel(body).unwrap();

            navigate(`/messages/${message?.channelId}`);
        } catch (error) {
            toast.error('Error joining channel');
        }
    };

    return (
        <ListItemButton sx={{ padding: 0 }} disableRipple onClick={onNavigate}>
            <ListItemAvatar>
                <Badge
                    overlap='circular'
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    color='primary'
                    sx={{
                        '& .MuiBadge-badge': {
                            border: '1px solid white',
                        },
                    }}
                >
                    <Avatar
                        variant='circular'
                        src={message?.profilePicture?.src}
                    >
                        {' '}
                        {`${message?.firstName.charAt(
                            0,
                        )}${message?.lastName.charAt(0)}`}
                    </Avatar>
                </Badge>
            </ListItemAvatar>
            <ListItemText
                primaryTypographyProps={{
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5,
                }}
                primary={
                    <>
                        <Typography sx={{ color: 'text.primary' }}>
                            {`${message?.firstName} ${message?.lastName}`}
                        </Typography>
                        <IconButton
                            disableRipple
                            sx={{
                                p: 0,
                                ml: 0.5,
                                color: 'primary.main',
                                '&:hover': {
                                    cursor: 'pointer',
                                    color: 'primary.contrastText',
                                    backgroundColor: 'transparent',
                                    background: 'none',
                                },
                            }}
                        >
                            <ChatIcon />
                        </IconButton>
                    </>
                }
            />
        </ListItemButton>
    );
};

const PrivateMessages = ({
    messages,
    reservationId,
}: {
    messages: any;
    reservationId: number;
}) => {
    return (
        <List
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1.2,
                maxHeight: '160px',
                overflowY: 'auto',
            }}
        >
            {messages?.map((message: any) => (
                <MessageItem
                    key={message.channelId}
                    message={message}
                    reservationId={reservationId}
                />
            ))}
        </List>
    );
};

export default PrivateMessages;
